export enum SettingsRequestTypeEnum {
  always = 'always',
  everytime = 'everytime',
  donotRepeat = 'donotRepeat',
}

export enum SettingsAutocheckEnum {
  EOB = 'EOB',
  AutoCheck = 'AutoCheck',
  AutoCheckCalls = 'AutoCheckCalls',
}
